import { render } from "./InvitationForm.vue?vue&type=template&id=0aaa4fba&ts=true"
import script from "./InvitationForm.vue?vue&type=script&lang=ts"
export * from "./InvitationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserForm/InvitationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aaa4fba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aaa4fba', __exports__)) {
    api.reload('0aaa4fba', __exports__)
  }
  
  module.hot.accept("./InvitationForm.vue?vue&type=template&id=0aaa4fba&ts=true", () => {
    api.rerender('0aaa4fba', render)
  })

}


export default __exports__